export default function Panel({ children, style, glow, pad = 24, accent, className }) {
  return (
    <div className={className} style={{
      position: 'relative',
      background: 'linear-gradient(160deg, var(--surface-2), var(--surface))',
      border: '1px solid var(--line)',
      borderRadius: 'var(--r-lg)',
      padding: pad,
      boxShadow: glow ? 'var(--shadow-card), var(--glow-red)' : 'var(--shadow-card)',
      ...style,
    }}>
      {accent && (
        <div style={{
          position: 'absolute', left: 0, top: 18, bottom: 18, width: 3, borderRadius: 3,
          background: 'linear-gradient(var(--accent), var(--accent-deep))',
          boxShadow: '0 0 12px var(--accent-glow)',
        }} />
      )}
      {children}
    </div>
  );
}
